import * as React from "react";
import * as ReactDOM from "react-dom";
import { observable } from "mobx";
import { MobXProviderContext, observer, Provider } from "mobx-react";
import { Box, Hidden, makeStyles } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  MUIBlock,
  MUIPreloader,
  SnackbarNotifier,
  Theme as theme,
} from "../MUI";
import axios from "axios";
import * as styles from "./styles.scss";

import { numberMorfform, pluralMorfForm, tl } from "../../../utils";
import { Popup, Button, SvgIcon } from "../../../components";

import FSStore from "./store";
import FSCourseslistStore from "./CoursesList/store";
import FSCourseStore from "./Course/store";
import FSTabsStore from "./Course/Tabs/store";
import FSViewerStore from "./Viewer/store";
import FSNotifierStore from "../../../components/Notifier/store";

import { Head } from "./Course/Head";
import { CoursesListContainer } from "./CoursesList";
import { Course } from "./Course";
import { Pocket } from "./Pocket";
import { Viewer } from "./Viewer";
import FSPopupNoticeStore from "../../../components/PopupNotice/store";
import { ATPlayer } from "../../../components/ATPlayer";
import VideoHelper, { IVideoInfo } from "../../../utils/video";
import { PlayCircleOutlineRounded } from "@material-ui/icons";
import { debounce, throttle } from "lodash";
import useDebounce from "../../../hooks/useDebounce";
import useCourseId from "../../../hooks/useCourseId";
import { ITranscription } from "../../../api/transcriptions";
interface IProps {
  data: {
    key: string;
    module: string;
    type: string;
    course_id: number;
    student_id?: number;
    section?: string;
    tab?: string;
    canDownload: boolean;
    canEdit: boolean;
    canDelete: boolean;
    isWidget?: boolean;
    onProtect?: any;
    onCancel?: any;
    onAttach?: any;
    onTransribeCreate?: any;
    popupNoticeType?: any;
  };
}

class Stores {
  @observable fsStore: FSStore;
  @observable fsCourseslistStore: FSCourseslistStore;
  @observable fsCourseStore: FSCourseStore;
  @observable fsTabsStore: FSTabsStore;
  @observable fsViewerStore: FSViewerStore;
  @observable fsNotifierStore: FSNotifierStore;
  constructor() {
    this.fsStore = new FSStore(this);
    this.fsCourseslistStore = new FSCourseslistStore(this);
    this.fsCourseStore = new FSCourseStore(this);
    this.fsTabsStore = new FSTabsStore(this);
    this.fsViewerStore = new FSViewerStore(this);
    this.fsNotifierStore = new FSNotifierStore(this);
  }
}
const stores = new Stores();


const useStyles = makeStyles((theme) => ({
  root: theme.overrides.MuiSnackbarContent.root,
  success: {
    backgroundColor: theme.palette.success.main,
    borderColor: theme.palette.success.dark,
  },
  error: {
    backgroundColor: theme.palette.error.main,
    borderColor: theme.palette.error.dark,
  },
  errorText: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.error.main,
  },
  previewRoot: {
    textDecoration: 'none',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.light,
    fontSize: 100,
    width: '100%', 
    height: 'auto', 
    // aspectRatio: '4/3',
    overflow: 'hidden',
    margin: '8px 0',
    '& svg': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    '& img': {
      maxHeight: 337,
      maxWidth: '100%',
      width: 'auto',
      height: 'auto',
    }
  }
}))

export const Filestorage = observer((props: IProps) => {
  const {
    fsStore,
    fsCourseStore,
    fsPopupNoticeStore,
    fsNotifierStore,
  } = React.useContext<{
    fsStore: FSStore;
    fsCourseStore: FSCourseStore;
    fsPopupNoticeStore: FSPopupNoticeStore;
    fsNotifierStore: FSNotifierStore;
  }>(MobXProviderContext);
  const [error, setErorr] = React.useState(false);
  const [videoInfoLoading, setVideoInfoLoading] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState("");
  const [videoInfo, setVideoInfo] = React.useState<null | IVideoInfo>(null);
  const [videoLinkError, setVideoLinkError] = React.useState(0);

  const [
    isCheckedFilesPocketOpen,
    setIsCheckedFilesPocketOpen,
  ] = React.useState(false);

  const course_id = useCourseId();

  if (!fsStore.wasLoaded) {
    fsStore.setInitialStore(props.data);
  }

  React.useEffect(() => {
    if (props.data.onTransribeCreate) {
      fsStore.onTranscribeCreate = (transcription: ITranscription, state: string) => props.data.onTransribeCreate(transcription, state);
    }
  }, []);

  React.useEffect(() => {
    if (!props.data.course_id && course_id) {
      fetchData(course_id);
    }
  }, [course_id]);

  React.useEffect(() => {
    fsStore.setInitialStore(props.data);
  }, [props.data.key]);

  React.useEffect(() => {
    if (props.data.course_id && !fsStore.wasLoaded) {
      fetchData();
    }

    if (props.data.type && props.data.type !== fsCourseStore.filterFilesType) {
      fsCourseStore.setFilterParams({ filestype: props.data.type });
    }
    if (props.data.popupNoticeType) {
      fsNotifierStore.setSuccessNote(props.data.popupNoticeType);
    }
  }, [props.data.course_id, props.data.type]);

  const fetchData = (course_id?: string) => {
    let url = `/panel/files/course`;
    url += `?course_id=${course_id ? course_id : props.data.course_id}`;
    axios
      .get(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
      .then((response) => {
        fsStore.onChangeCourse(response.data);
      })
      .catch(() => {
        setErorr(true);
      });
  };

  const classes = useStyles({});

  React.useEffect(() => {
    if (fsStore.isWidget) {
      history.pushState(
        "",
        document.title,
        window.location.pathname + window.location.search + "#filestorage"
      );
      window.onhashchange = function() {
        var s = window.location.hash.toString();
        if (s != "#filestorage") {
          fsStore.onCancel();
        }
      };
    }
  }, []);


  const getVideoLinkInfo = React.useCallback(async (e: React.FocusEvent<HTMLInputElement>) => {
    setVideoInfoLoading(true);
    let info = null;
    if (e.target.value) {
      try {
        info = await VideoHelper.getInfo(e.target.value);
      } catch (error) {
        console.log(error)
        setVideoLinkError(error.response.status);
        setVideoInfoLoading(false);
        return;
      }
    }
    setVideoLinkError(0);
    setVideoInfo(info);
    setVideoInfoLoading(false);

  }, [])




  const handleUploadViaLink = async () => {
    const res = await fsStore.uploadVideoViaLink(videoLink, videoInfo.name);
    if (res[0].message && res[0].message === "SERVICES_DISABLED") {
      window.openServicesDisabledModal(true);
      fsCourseStore.toggleFileUploadInProgress(false);
      return;
    }
    fsCourseStore.onUpload([res[0].file], fsStore.isWidget)
    fsNotifierStore.setSuccessfullyAddedNote();
    fsStore.switchCheckedFilesWarning(false, false, true);
    setVideoLink('');
    setVideoInfo(null);
  }

  const debouncedVideoLinkInfo = useDebounce((e: React.FocusEvent<HTMLInputElement>) => getVideoLinkInfo(e), 300)

  return (
    <div className={styles.filestorage}>
      {props.data.course_id && !fsStore.wasLoaded ? (
        error ? (
          <>
            <Box>{tl("Произошла ошибка. Попробуйте повторить позднее.")}</Box>
            <Button onClick={fetchData}>{tl("Обновить страницу")}</Button>
          </>
        ) : fsStore.isWidget ? (
          <MUIBlock data={{ style: { minHeight: "100vh" } }} pInner={0}>
            <Head />
            <MUIPreloader />
          </MUIBlock>
        ) : (
          <MUIPreloader />
        )
      ) : !fsStore.course_id ? (
        <CoursesListContainer />
      ) : (
        <Course />
      )}
      <Hidden only="xs">
        {fsStore.isFilesCheckAvailable && fsStore.getCheckedFilesCount ? (
          <Pocket
            isOpen={isCheckedFilesPocketOpen}
            onToggle={() => {
              setIsCheckedFilesPocketOpen(!isCheckedFilesPocketOpen);
            }}
          />
        ) : null}
      </Hidden>
      <Viewer />
      <SnackbarNotifier />
      <Popup
        header={tl("Вы не прикрепили выбранные файлы")}
        bottomCSSModifier="mobile-wrap"
        width="464px"
        bottom={
          <>
            <div className="modal-panel__section">
              <span
                className="button button_lighter"
                onClick={() => {
                  fsNotifierStore.setNoteOnUpload(fsStore.getCheckedFilesCount);

                  fsStore.switchCheckedFilesWarning(
                    false,
                    true,
                    fsStore.addVideoLinkTriggered
                  );
                }}
              >
                {tl("Не прикреплять и загрузить")}
              </span>
            </div>
            <div className="modal-panel__section">
              <span
                className="button"
                onClick={() => {
                  fsNotifierStore.setSuccessfullyAddedNote();

                  fsStore.switchCheckedFilesWarning(
                    false,
                    false,
                    fsStore.addVideoLinkTriggered
                  );
                }}
              >
                {tl("Прикрепить и загрузить")}
              </span>
            </div>
          </>
        }
        isVisible={fsStore.filesCheckedWarning}
        onClose={() => {
          fsStore.switchCheckedFilesWarning(false);
        }}
        onCancel={fsStore.closeCheckedFilesWarning}
        info
      >
        {tl("Чтобы ")}
        <b>{tl("загрузить новые файлы,")}</b>
        {tl(" прикрепите к уроку уже ")}
        {numberMorfform(
          fsStore.getCheckedFilesCount,
          tl(" выбранный "),
          tl(" выбранные "),
          tl(" выбранные ")
        )}
        {fsStore.getCheckedFilesCount}
        {numberMorfform(
          fsStore.getCheckedFilesCount,
          tl(" файл"),
          tl(" файла"),
          tl(" файлов")
        )}
        {tl(", или этот выбор пропадет.")}
      </Popup>
      <Popup
        width="450px"
        header={
          <span
            className="link"
            onClick={() => {
              fsStore.toggleAddVideoLink();
            }}
          >
            <SvgIcon type="fs-back" /> {tl("Вернуться в файловое хранилище")}
          </span>
        }
        bottom={
          !videoLink && !videoInfo ? (
            <>
              <span />
              <span className="button disabled">{tl("Добавить")}</span>
            </>
          ) : (
            <>
              <span />
              <div className="modal-panel__section">
                <span
                  className="button button_lighter"
                  onClick={() => {
                    fsNotifierStore.setNoteOnUpload(
                      fsStore.getCheckedFilesCount
                    );

                    fsStore.switchCheckedFilesWarning(false, true, true);
                  }}
                >
                  {tl("Отмена")}
                </span>
                <span
                  className="button"
                  onClick={() => {
                    // fsStore.onAttachVideoLink(videoLink);
                    // fsNotifierStore.setSuccessfullyAddedNote();

                    // fsStore.switchCheckedFilesWarning(false, false, true);
                    handleUploadViaLink()
                  }}
                >
                  {tl("Добавить")}
                </span>
              </div>
            </>
          )
        }
        isVisible={fsStore.addVideoLink}
        onClose={() => {
          fsStore.toggleAddVideoLink();
        }}
        info
      >
        <b>{tl("Вставьте ссылку на видеоролик")}</b>
        <div className="input" style={{ margin: "8px 0" }}>
          <input
            className="input"
            type="text"
            placeholder="https://"
            value={videoLink}
            onChange={(e) => {
              setVideoLink(e.target.value);
              setVideoInfo(null);
              //@ts-ignore
              debouncedVideoLinkInfo(e);
            }}
          />
        </div>
        {tl("Например из Youtube, Vimeo, Яндекс.Диск, Rutube, VK Видео")}
        {videoLinkError === 403 && <div><span className={classes.errorText}>{tl('Видео недоступно, возможно оно защищено настройками приватности')}</span></div>}
        {videoLink && !videoInfoLoading && !videoInfo &&  <div><span className={classes.errorText}>{tl('Данная ссылка не поддерживается.')}</span></div>}
        {videoLink && videoInfoLoading && <h3>Идет формирование превью...</h3>}
        {videoInfo && 
          <Box display="flex" flexDirection="column" flex={1}>
            <a className={classes.previewRoot} href={videoLink} target="_blank">
              <PlayCircleOutlineRounded fontSize="inherit" />
              <img height="100%" width="auto" src={videoInfo.preview} referrerPolicy="no-referrer" alt={videoInfo.name} />
            </a>
            <h5>{videoInfo.name}</h5>
          </Box>}
      </Popup>
    </div>
  );
});

export class EmbededFilestorage extends React.Component<IProps> {
  render() {
    return (
      <div className="filestorage-aswidget-modal">
        <div className="filestorage-aswidget-modal__holder">
          <div
            className="filestorage-aswidget-modal__trigger"
            onClick={this.props.data.onCancel}
          />
          <div className="filestorage-aswidget-modal__wrap modal_fileselect">
            <Provider {...stores} data={this.props.data.key}>
              <ThemeProvider theme={theme}>
                <Filestorage data={this.props.data} key={this.props.data.key} />
              </ThemeProvider>
            </Provider>
          </div>
        </div>
      </div>
    );
  }
}

const renderEmbedFileStorage = (data: any) => {
  return (
    <Provider {...stores} key={data.key}>
      <ThemeProvider theme={theme}>
        <Filestorage data={data} key={data.key} />
      </ThemeProvider>
    </Provider>
  );
};

export default renderEmbedFileStorage;